// App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./components/DashboardTab.jsx";
import CompostShedManagement from "./components/CompostShedTab.jsx";
import MapView from "./components/MapViewTab.jsx";
import LoginForm from "./components/LoginForm.jsx";
import ForgotPassword from "./components/ForgotPassword.jsx";
import Profile from "./components/Profile.jsx";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import PrivacyPolicy from "./components/PrivacyPolicy.jsx";
// --- Private route for authentication ---
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const userData = JSON.parse(localStorage.getItem("userData"));
const username = localStorage.getItem("rememberUsername");
  if (!token || !userData?.expiresAt) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("username");
    return <Navigate to="/" replace />;
  }

  const currentTime = new Date();
  const expiryTime = new Date(userData.expiresAt);

  if (currentTime >= expiryTime) {
    alert("Session expired. Please log in again.");
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    return <Navigate to="/" replace />;
  }

  return children;
};





// --- Dashboard layout with tabs ---
function DashboardLayout() {
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [overrideContent, setOverrideContent] = useState(null); // ✅ to render Profile
  const [applyClicked, setApplyClicked] = useState(0);

  const today = new Date();
  const formatDate = (date) => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const [fromDate, setFromDate] = useState(formatDate(firstDayOfMonth));
  const [toDate, setToDate] = useState(formatDate(today));
  const [activeRange, setActiveRange] = useState("Month");

  const handleDateFilter = (type) => {
    const now = new Date();
    let newFromDate = formatDate(now);
    let newToDate = formatDate(now);

    if (type === "Week") {
      const past = new Date();
      past.setDate(now.getDate() - 6);
      newFromDate = formatDate(past);
    } else if (type === "Month") {
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      newFromDate = formatDate(start);
    }

    setActiveRange(type);
    setFromDate(newFromDate);
    setToDate(newToDate);
  };

  return (
    <div className="min-h-screen bg-gray-100 font-sans flex flex-col">
      {/* Pass setOverrideContent and tab state to Header */}
      <Header 
        setOverrideContent={setOverrideContent} 
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        overrideContent={overrideContent}
      />

      {/* Content area */}
      <main className="flex-1 p-4 overflow-y-auto">
        {overrideContent ? overrideContent :
          activeTab === "Dashboard" ? (
            <Dashboard 
              fromDate={fromDate} 
              toDate={toDate} 
              applyClicked={applyClicked}
              setFromDate={setFromDate}
              setToDate={setToDate}
              setApplyClicked={setApplyClicked}
              activeRange={activeRange}
              handleDateFilter={handleDateFilter}
            />
          ) :
          activeTab === "Map View" ? (
            <MapView 
              fromDate={fromDate} 
              toDate={toDate} 
              applyClicked={applyClicked}
              setFromDate={setFromDate}
              setToDate={setToDate}
              setApplyClicked={setApplyClicked}
              activeRange={activeRange}
              handleDateFilter={handleDateFilter}
            />
          ) :
          (
            <CompostShedManagement 
              fromDate={fromDate} 
              toDate={toDate} 
              applyClicked={applyClicked}
              setFromDate={setFromDate}
              setToDate={setToDate}
              setApplyClicked={setApplyClicked}
              activeRange={activeRange}
              handleDateFilter={handleDateFilter}
            />
          )
        }
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}



// --- Main App component ---
function App() {
  return (
    <Router>
      <Routes>

<Route path="/privacy-policy" element={<PrivacyPolicy />} />
  <Route path="/" element={<LoginForm />} />
  <Route path="/forgot-password" element={<ForgotPassword />} />
  <Route
    path="/dashboard/*"
    element={
      <PrivateRoute>
        <DashboardLayout />
      </PrivateRoute>
    }
  />
  {/* ✅ Add Profile route */}
  <Route
    path="/profile"
    element={
      <PrivateRoute>
        <Profile />
      </PrivateRoute>
    }
  />
</Routes>

    </Router>
  );
}

export default App;
